import { render, staticRenderFns } from "./StatusWrong.vue?vue&type=template&id=0a4fca07&scoped=true"
import script from "./StatusWrong.vue?vue&type=script&lang=js"
export * from "./StatusWrong.vue?vue&type=script&lang=js"
import style0 from "./StatusWrong.vue?vue&type=style&index=0&id=0a4fca07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4fca07",
  null
  
)

export default component.exports